module.exports = __webpack_public_path__ + "img/pin-triple-diamond.40149f02.png";